import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderPaper: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolderPaper"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H17V5H21V10H22.0039V21H2.00391V7H3V3ZM19 10V7H17V10H19ZM15 10V5H5V7H9.41812L12.4181 10H15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderPaper;
